/**
 * Theme Safety Guard
 * 
 * Prevents extreme theme configurations from breaking performance or causing visual issues.
 * Clamps all numeric values to safe ranges.
 */

const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

export function sanitizeUniverseTheme(theme) {
  if (!theme || typeof theme !== "object") return theme;

  const safe = { ...theme };

  // Background
  safe.bg = safe.bg || {};
  safe.bg.starfieldDensity = clamp(Number(safe.bg.starfieldDensity ?? 90), 20, 220);
  safe.bg.grain = clamp(Number(safe.bg.grain ?? 0.06), 0, 0.16);
  safe.bg.nebula = Boolean(safe.bg.nebula);

  // FX
  safe.fx = safe.fx || {};
  safe.fx.glow = clamp(Number(safe.fx.glow ?? 0.7), 0, 1.4);
  safe.fx.shimmer = clamp(Number(safe.fx.shimmer ?? 0.6), 0, 1.2);
  safe.fx.ripples = Boolean(safe.fx.ripples);

  // Motion multipliers
  safe.motion = safe.motion || {};
  safe.motion.twinkle = clamp(Number(safe.motion.twinkle ?? 0.8), 0, 1.5);
  safe.motion.drift = clamp(Number(safe.motion.drift ?? 0.6), 0, 1.2);
  safe.motion.pulse = clamp(Number(safe.motion.pulse ?? 0.7), 0, 1.5);

  // Lines
  safe.lines = safe.lines || {};
  safe.lines.opacity = clamp(Number(safe.lines.opacity ?? 0.9), 0, 1.4);
  safe.lines.width = clamp(Number(safe.lines.width ?? 1.0), 0.5, 2.2);
  safe.lines.energy = clamp(Number(safe.lines.energy ?? 0.8), 0, 1.6);

  // Nodes
  safe.nodes = safe.nodes || {};
  safe.nodes.baseRadius = clamp(Number(safe.nodes.baseRadius ?? 1.0), 0.7, 1.6);
  safe.nodes.aura = clamp(Number(safe.nodes.aura ?? 1.0), 0.6, 1.8);

  // Toggles flags (if included on theme)
  safe.powerSaver = Boolean(safe.powerSaver);
  safe.reduceMotion = Boolean(safe.reduceMotion);

  return safe;
}
